import React from 'react';
import SEO from '../../../component/common/SEO';
import { pageSEO } from '../../../config/seoConfig';
import './style.css';

export default function PrivacyPolicy() {
  return (
    <div className="privacy_bg">
      <SEO {...pageSEO.privacyPolicy} />
      {/* Banner */}
      <div className="privacy_banner">{/* <h1>Privacy Policy</h1> */}</div>

      {/* Content */}
      <div className="privacy_content">
        <h1>Privacy Policy – Importerr.com</h1>
        <h3>(Boundless Trends Pvt. Ltd.)</h3>

        <p>
          Governing Law: Indian Laws including the Information Technology Act, 2000 and the Digital Personal Data Protection Act, 2023 (as and when notified).
        </p>

        <section>
          <h2 className="privacy_heading">1. Introduction</h2>
          <p>This Privacy Policy explains how Importerr.com (&quot;we&quot;, &quot;our&quot;, &quot;us&quot;) collects, uses, stores, shares, and protects personal information provided by users (&quot;you&quot;, &quot;your&quot;) while accessing or using our digital platform. We are committed to safeguarding your privacy and handling your data in compliance with applicable Indian laws, including the Information Technology Act, 2000 and rules thereunder, and other relevant regulations.</p>
          <br />
          <p>By accessing or using Importerr.com, you acknowledge and consent to the practices described in this Privacy Policy.</p>
        </section>

        <section>
          <h2 className="privacy_heading">2. Information We Collect</h2>
          <p>We may collect the following information:</p>
          <ul className="privacy_list">
            <li>Personal information (name, email, phone, address, KYC documents).</li>
            <li>Transaction information (orders placed, payment details, invoices).</li>
            <li>Device and usage data (IP address, browser type, cookies, user activity).</li>
            <li>Communication records (emails, chats, messages shared with us).</li>
          </ul>
        </section>

        <section>
          <h2 className="privacy_heading">3. Purpose of Data Collection</h2>
          <p>We collect and process your information to:</p>
          <ul className="privacy_list">
            <li>
              Provide our services and process your orders.
            </li>
            <li>
              Verify identity and comply with legal requirements.
            </li>
            <li>Improve user experience and platform security.</li>
            <li>Send notifications, updates, and support communication.</li>
            <li>Detect fraud, misuse, or violations of Indian law.</li>
            <li>Compliance with the law (KYC etc)</li>
          </ul>
        </section>

        <section>
          <h2 className="privacy_heading">4. Data Sharing</h2>
          <p>
            We may share your data with:
          </p>
          <ul className="privacy_list">
            <li>Third-party suppliers, logistics partners, and payment gateways.</li>
            <li>Government and regulatory authorities as required by law.</li>
            <li>Our affiliates,customer support, service providers, and advisors.</li>
            <li>Professional advisors and IT service providers</li>
            <li>We do not sell your personal data to third parties.</li>
          </ul>
        </section>

        <section>
          <h2 className="privacy_heading">5. Data Security</h2>
          <p>
           All user data is stored on secure servers with appropriate technical and organizational safeguards to prevent unauthorized access, alteration, disclosure, or destruction. We follow industry-standard encryption and access control measures.. However, no system is fully secure, and we disclaim liability for unauthorized access, breaches, or misuse beyond our reasonable control.
          </p>
        </section>

        <section>
          <h2 className="privacy_heading">6. Data Retention</h2>
          <p>All the collected user data is retained by us for reasonable period of time on secured servers located (in India/ overseas) to honour legal compliances, dispute resolution, and service provision.</p>
        </section>

        <section>
          <h2 className="privacy_heading">7. Your Rights</h2>
          <p>As per Indian laws, you have rights to:</p>
          <ul className="privacy_list">
            <li>Access, correct, or update your data.</li>
            <li>Withdraw consent for processing.</li>
            <li>Request deletion, subject to legal limitations.</li>
            <li>File a grievance with our Data Protection Officer/ Customer care.</li>
          </ul>
        </section>

        <section>
          <h2 className="privacy_heading">8. Grievance Redressal</h2>
          <p>For concerns, contact:</p>
          <p>
            <span className="bold_text">Importerr.com (DPDP Act 2023- is yet to be notified) on being notified, the provisions of the Act shall apply automatically to those presents.</span>
            <br />📧 Email: <a href="mailto:contact@importerr.com">contact@importerr.com</a>
            <br />
          </p>
        </section>

        <section>
          <h2 className="privacy_heading">9. Changes to Privacy Policy</h2>
          <li>We may update this Privacy Policy from time to time.. The user is advised to revisit the privacy policy as and when the changes/ updates are made. Your continued access or use of the platform following the publication of any updated Privacy Policy shall constitute your deemed acceptance of the revised terms.</li>
          <li className="bold_item">By accepting this Privacy Policy, you also agree that such acceptance applies to future updates, unless you choose to discontinue use of the platform.</li>
        </section>
      </div>
    </div>
  );
}
